// Fetches editable text content from the "Content" tab of the same Google
// Sheet that already powers class registration (see GET /api/content in
// server.js). If that tab doesn't exist yet, or a specific key hasn't been
// filled in, callers fall back to the hardcoded defaults below so nothing on
// the site ever breaks while content is being migrated over.

export async function fetchContent() {
  try {
    const res = await fetch('/api/content');
    if (!res.ok) return {};
    return await res.json();
  } catch {
    return {};
  }
}

// Same idea, but for a page with its own dedicated sheet tab (Rates, Policy,
// Performances) instead of the shared Content tab. `page` must match one of
// the names the server allowlists in ALLOWED_PAGE_CONTENT_TABS.
export async function fetchPageContent(page) {
  try {
    const res = await fetch(`/api/page-content/${encodeURIComponent(page)}`);
    if (!res.ok) return {};
    return await res.json();
  } catch {
    return {};
  }
}

// Content cells hold one bullet per line (Alt+Enter in Google Sheets).
export function contentLines(content, key, fallbackLines) {
  const raw = content && content[key];
  if (!raw || !raw.trim()) return fallbackLines;
  return raw
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean);
}

export function contentText(content, key, fallbackText) {
  const raw = content && content[key];
  return raw && raw.trim() ? raw : fallbackText;
}
